import React from 'react';
import { ProactiveEngineStateEnum } from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import { useTranslation } from 'react-i18next';

const proactiveEngineStateMapping = {
  [ProactiveEngineStateEnum.Deactivated]: 'Deactivated',
  [ProactiveEngineStateEnum.Activated]: 'Activated',
  [ProactiveEngineStateEnum.Unavailable]: 'Unavailable',
  default: 'Unknown',
};

export const EngineState = () => {
  const { t } = useTranslation();
  const { proactiveEngineStore } = useStores();

  return (
    <span className="engine-state">
      {t(
        proactiveEngineStateMapping[proactiveEngineStore.proactiveEngineState] ||
          proactiveEngineStateMapping['default'],
      )}
    </span>
  );
};
